import type { Patient } from '@/types'

export const PATIENTS_PER_PAGE = 10

export const statusBadgeVariant: Record<
  Patient['status'],
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  ACTIVE: 'default',
  DISCHARGED: 'secondary',
  DECEASED: 'destructive',
}
